module.exports = __webpack_public_path__ + "img/google_icon.9ac1a3a2.png";